import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ProductCreateFoodcostInfoPage } from "../../product-create/product-create-foodcost/product-create-foodcost-info/product-create-foodcost-info";
import { ProductCreateWfoodcostInfoPage } from "../../product-create/product-create-without-foodcost/product-create-wfoodcost-info/product-create-wfoodcost-info";
import { ProviderOrderAddPage } from '../../../providers/orders/provider-order-add/provider-order-add';
import { Globals } from '../../../../globals';

/**
 * Generated class for the ProductViewNamePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-view-name',
    templateUrl: 'product-view-name.html',
})
export class ProductViewNamePage {
    @Input() product: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,) {
    }

    edit() {

        if (this.product.sub_recipe == false) {
            this.navCtrl.push(ProductCreateWfoodcostInfoPage, {
                update_state: true,
                product_uid: this.product.UID,
                product_name: this.product.name,
                name_en: this.product.name_en,
                name_fr: this.product.name_fr,
                name_it: this.product.name_it,
                name_de: this.product.name_de,
                name_ca: this.product.name_ca,
                measurement: this.product.measurement,
                stock: this.product.stock,
                stock_alert: this.product.stock_alert,
                stock_max: this.product.stock_max,
                tags: this.product.tags,
                pvp: this.product.pvp,
                description_es: this.product.description_es,
                description_en: this.product.description_en,
                description_fr: this.product.description_fr,
                description_it: this.product.description_it,
                description_de: this.product.description_de,
                description_ca: this.product.description_ca,
                product: this.product
            })
        } else {
            this.navCtrl.push(ProductCreateFoodcostInfoPage, {
                update_state: true,
                product_uid: this.product.UID,
                product_name: this.product.name,
                name_en: this.product.name_en,
                name_fr: this.product.name_fr,
                name_it: this.product.name_it,
                name_de: this.product.name_de,
                name_ca: this.product.name_ca,
                measurement: this.product.measurement,
                stock: this.product.stock,
                stock_alert: this.product.stock_alert,
                stock_max: this.product.stock_max,
                tags: this.product.tags,
                description_es: this.product.description_es,
                description_en: this.product.description_en,
                description_fr: this.product.description_fr,
                description_it: this.product.description_it,
                description_de: this.product.description_de,
                description_ca: this.product.description_ca,
                product: this.product
            })
        }


    }

    openProviderOrderAdd(element) {
        this.navCtrl.push(ProviderOrderAddPage, {
            element: element,
            type: 'product'

        });
    }


}



// WEBPACK FOOTER //
// ./src/pages/products/product-view/product-view-name/product-view-name.ts